import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { CheckBoxModule } from 'app/shared/components/check-box/check-box.module';
import { ListModule } from 'app/shared/components/list/list.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { ObjectTypeFilterFormComponent } from './object-type-filter-form.component';

@NgModule({
  imports: [
    CommonModule,
    ListModule,
    CheckBoxModule,
    ButtonModule,
    ModalModule,
  ],
  declarations: [ObjectTypeFilterFormComponent],
  exports: [ObjectTypeFilterFormComponent],
})
export class ObjectTypeFilterFormModule {}
